module.exports = __webpack_public_path__ + "img/tagaveritasako_7-9-2021.b15cb41c.jpg";